import PropTypes from 'prop-types'
import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import 'components/UseDesk/use-desk.scss'

const UseDeskComponent = () => {
  const dispatch = useDispatch()
  const { user, i18n = 'ru' } = useSelector(({ app }) => app)

  const initUseDesk = useCallback(
    ({ email, id, usedesk_token = null }) => {
      const oldScriptElement = document.getElementById('usedesk-script')
      const oldMessengerElement = document.getElementById('usedesk-messenger')

      if (oldScriptElement) {
        oldScriptElement.remove()
      }

      if (oldMessengerElement) {
        oldMessengerElement.remove()
      }

      const props = {
        email: email,
        phone: '-',
        name: email,
      }

      if (usedesk_token) {
        props.token = usedesk_token
      }

      global.__widgetInitCallback = function () {
        let expectedWidget = global.usedeskMessenger

        expectedWidget.identify({
          ...props,
          additional_fields: [
            {
              id: 24625,
              value: id,
            },
          ],
        })
      }

      global.__usedeskWidgetInitedCallback = function () {
        const token = global.usedeskMessenger.getChatToken()

        if (usedesk_token !== token) {
          dispatch({
            type: 'USER/UPDATE_USER',
            payload: { usedesk_token: token },
          })
        }
      }

      const useDeskScriptElement = document.createElement('script')
      useDeskScriptElement.setAttribute('id', `usedesk-script`)
      useDeskScriptElement.setAttribute(
        'src',
        `https://lib.usedesk.ru/secure.usedesk.ru/widget_${
          window['USE_DESK_ID_' + i18n.toUpperCase()]
        }.js`,
      )

      document.body.appendChild(useDeskScriptElement)
    },
    [global, i18n],
  )

  useEffect(() => {
    if (!user?.id) {
      return
    }

    if (process.env.NODE_ENV === 'production') {
      initUseDesk(user)
    }
  }, [user, i18n])

  return null
}

UseDeskComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
}
export default UseDeskComponent
